import { listCross, listStraight, listStraightThumb } from './listCross'
import { webKnots } from '../../../common/back/lace/webKnots'

export const laceOfWristBeltCrossDrawer = (ctx: CanvasRenderingContext2D, color: string, isFirstBackStyle: boolean): void => {
  if (isFirstBackStyle) return
  listCross(ctx, color) // 手口左のクロス部分
  webKnots(ctx, color, -170, 400, 10, 0.8) // 手首ベルト左の結び目
}

export const laceOfWristBeltStraightDrawer = (ctx: CanvasRenderingContext2D, color: string, isFirstBackStyle: boolean): void => {
  if (isFirstBackStyle) return
  listStraight(ctx, color, 0, 0) // 手口左のクロス部分
  webKnots(ctx, color, -165, 390, 10, 0.8) // 手首ベルト左の結び目
  listStraightThumb(ctx, color, 0, 0)
  listStraightThumb(ctx, color, 7, 45)

  ctx.beginPath()
  ctx.moveTo(505, 500) // 左上
  ctx.quadraticCurveTo(517, 516, 518, 552) // 左下
  ctx.quadraticCurveTo(528, 545, 527, 537) // 右下
  ctx.quadraticCurveTo(522, 509, 510, 492) // 右上
  ctx.quadraticCurveTo(503, 492, 505, 500) // 左上
  ctx.fill()
  ctx.moveTo(505, 496) // 左上
  ctx.quadraticCurveTo(519, 516, 520, 551) // 左下
  ctx.stroke()
  ctx.closePath()
}
